@if (currentOpeningTimesService.component$ | async; as input) {
  <div>
    @if (input.type === "overview") {
      <div>
        <app-opening-times-overview></app-opening-times-overview>
      </div>
    }
    @if (input.type === "specificOpeningTimes") {
      <div>
        <app-specific-opening-times></app-specific-opening-times>
      </div>
    }
  </div>
}
